import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';

import {
	setModoTela, initForm, gerarBoletim, salvar, getListaHistorico, salvarComentarioVisto,
	salvarTratativa, excluirTratativa, getListaTratativa,
	salvarComentarioGestao, excluirComentarioGestao, getListaComentarioGestao
} from './ocorrenciaActions';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';

class OcorrenciaForm extends Component {

	state = {

	}

	componentDidMount() {

		const fileSelectorArquivo = document.createElement('input');
		fileSelectorArquivo.setAttribute('type', 'file');
		fileSelectorArquivo.addEventListener("change", (data) => {

			let reader = new FileReader();
			let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
			if (!file) {
				file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
			}

			if (file) {

				if (!file.type.includes('application/pdf')
					&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
					setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
					return;
				}

				reader.onloadend = () => {

					let lista = (this.props.formularioValues.arquivo || []).map(item => item);
					lista.push({
						arquivo_base64: reader.result
					});

					this.props.initForm({
						...this.props.formularioValues,
						arquivo: lista
					});

				}

				reader.readAsDataURL(file);

			}
		});

		this.fileSelectorArquivo = fileSelectorArquivo;

		const fileSelectorArquivoGestao = document.createElement('input');
		fileSelectorArquivoGestao.setAttribute('type', 'file');
		fileSelectorArquivoGestao.addEventListener("change", (data) => {

			let reader = new FileReader();
			let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
			if (!file) {
				file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
			}

			if (file) {

				if (!file.type.includes('application/pdf')
					&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
					setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
					return;
				}

				reader.onloadend = () => {

					let lista = (this.props.formularioValues.arquivo_gestao || []).map(item => item);
					lista.push({
						arquivo_base64: reader.result
					});

					this.props.initForm({
						...this.props.formularioValues,
						arquivo_gestao: lista
					});

				}

				reader.readAsDataURL(file);

			}
		});

		this.fileSelectorArquivoGestao = fileSelectorArquivoGestao;
	}

    componentWillMount() {

		this.props.getListaHistorico(this.props.formularioValues.id);
		this.props.getListaTratativa(this.props.formularioValues.id || 0);
		this.props.getListaComentarioGestao(this.props.formularioValues.id || 0);
    }

    render() {

		let isDocumentoVPR = this.props.formularioValues.id_documento_viagem 
			|| this.props.formularioValues.id_vale_pedagio_entrada
			|| this.props.formularioValues.id_vale_pedagio_saida
			|| this.props.formularioValues.id_vale_pedagio_transferencia
			|| this.props.formularioValues.avulsa;
			
		let readOnly = this.props.excluir || this.props.gestao || (
			this.props.formularioValues 
			&& this.props.formularioValues.id 
			&& isDocumentoVPR
			&& this.props.formularioValues.id_usuario_inclusao != this.props.sessao.id //Usuário que incluiu pode ter acesso total

			&& this.props.sessao.id != 1 // INFINITUM

			&& this.props.sessao.id != 13 // Mauricio Junior Sfalcin
			&& this.props.sessao.id != 30 // Clarissa Brauner

			&& this.props.sessao.id != 48 // Bruna Schneider Padilha
			&& this.props.sessao.id != 304 // Patricia Andressa Fernandes Knechtel
			&& this.props.sessao.id != 31 // Alana Costa
			&& this.props.sessao.id != 58 // Vanessa Brizzi da Silva
			&& this.props.sessao.id != 67 // Agatha Nila Correa Maciel
			&& this.props.sessao.id != 120 // Bruna Grazieli Barbosa 
			&& this.props.sessao.id != 270 //Jessica da Silva de Andrade

			&& this.props.sessao.id != 37 //Rodrigo Soares
		) ? 'readOnly' : '';

		const gestaoReciclagem = this.props.formularioValues.id_status_gestao == 3; //Em Reciclagem
		const gestaoFinalizada = this.props.formularioValues.id_status_gestao == 4; //Finalizada

		let dentroMes = true;
		try {
			if (!this.props.formularioValues.alterandoData) {
				dentroMes = (
					new Date(DateFormat.formatarDataHoraTelaParaSql(this.props.formularioValues.datahora_ocorrencia)).getFullYear() == new Date().getFullYear()
					&& (
						new Date(DateFormat.formatarDataHoraTelaParaSql(this.props.formularioValues.datahora_ocorrencia)).getMonth() == new Date().getMonth()
						|| new Date(DateFormat.formatarDataHoraTelaParaSql(this.props.formularioValues.datahora_ocorrencia)).getMonth() == new Date().getMonth() - 1
					)
				) || (
					new Date(DateFormat.formatarDataHoraTelaParaSql(this.props.formularioValues.datahora_ocorrencia)).getFullYear() == new Date().getFullYear() -1
					&& new Date(DateFormat.formatarDataHoraTelaParaSql(this.props.formularioValues.datahora_ocorrencia)).getMonth() == 11
					&& (new Date().getMonth() == 11 || new Date().getMonth() == 0)
				)

			}
		} catch (ex) {
			
		}

		/*
			ADMIN
			1-INFINITUM
			
			SUPERVISOR
			13-Mauricio Junior Sfalcin
			30-Clarissa Brauner
			23-Alesandra Fatima da Silva Scheuer
			
			OPERADOR
			48-Bruna Schneider Padilha
			304-Patricia Andressa Fernandes Knechtel
			31-Alana Costa
			58-Vanessa Brizzi da Silva

			USUÁRIO
			23-Alesandra Fatima da Silva Scheuer
			67 - Agatha Nila Correa Maciel
			120 - Bruna Grazieli Barbosa
			270 - Jessica da Silva de Andrade
			68- Arielli Jaqueline Gross Boeno
			76-Viviane Rodrigues Moreira
			70-Elisangela Lira
			71-Ricardo Lazzaretti Neto
			72-Isadora Konarzewsky Patzer
			73-Flaviane Rodrigues Oliveira
			74-Thiago Ribeiro Lopes
			75-Daniela Ribeiro Autori
			20-Andrea Andrade Alves
			37-Rodrigo Soares
			9 -Fabiana Ribeiro de Almeida-
			60-EDMILSON DA SILVA SERPA
			10-Kelvin Lima de Lemos
			77-Lucas dos Santos Serpa
			78-Carlos Eduardo Pereira
			79-Jefferson da Cruz Cardoso
			6 -Diego Metztorf Mallmann 
		*/

		let editaMes = true;
		if (isDocumentoVPR
			&& this.props.formularioValues.id
			&& !dentroMes
		) {
			editaMes = false;
		}

		let acessoResponsavel = true;
		if (!editaMes) {
			acessoResponsavel = false;
			if (readOnly && !this.props.excluir && this.props.formularioValues && this.props.formularioValues.id && isDocumentoVPR) {
				//Usuário responsável e aprovador pode ter acessoa parcial
				if (this.props.formularioValues.id_usuario_responsavel == this.props.sessao.id) {
					acessoResponsavel = true;
				}
			}
		}

		let acessoAprovador = true;
		if (!editaMes) {
			acessoAprovador = false;
			if (readOnly && !this.props.excluir && this.props.formularioValues && this.props.formularioValues.id && isDocumentoVPR) {
				//Usuário responsável e aprovador pode ter acessoa parcial
				if (this.props.formularioValues.id_usuario_aprovador == this.props.sessao.id) {
					acessoAprovador = true;
				}
			}
		}

		let podeExcluir = true;
		if (isDocumentoVPR
			&& this.props.formularioValues.id
			&& this.props.sessao.id != 1 // INFINITUM
			&& this.props.sessao.id != 13 // Mauricio Junior Sfalcin
			&& this.props.sessao.id != 30 // Clarissa Brauner
			&& this.props.sessao.id != 48 // Bruna Schneider Padilha
			&& this.props.sessao.id != 304 // Patricia Andressa Fernandes Knechtel
		) {
			podeExcluir = false;
		}

		let listaComentarios = this.props.listaHistorico.filter(item => item.coluna == 'comentarios' && item.atual);
		listaComentarios.sort((a, b) => a.id < b.id ? 1 : -1);

        return (
			<>
				{this.props.resumoDocumento && 
				<ContentCard>
					<ContentCardHeader>
						<Row>
							<div 
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									flexWrap: 'wrap',
									padding: 8
								}}>
								<div style={{ fontSize: 14, padding: 4 }}><b>Número: </b> {this.props.formularioValues.id}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Solicitação: </b> {this.props.formularioValues.solicitacao}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Romaneio: </b> {this.props.formularioValues.romaneio}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Emissão: </b> {this.props.formularioValues.datahora_viagem}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Descarga: </b> {this.props.formularioValues.datahora_descarga}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Tipo Doc: </b> {this.props.formularioValues.tipo_documento}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Documento: </b> {this.props.formularioValues.numero_documento}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>MIC: </b> {this.props.formularioValues.mic_documento}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Shipping: </b> {this.props.formularioValues.shipping}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Veículo: </b> {this.props.formularioValues.cavalo}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Motorista Entrega: </b> {this.props.formularioValues.nome_motorista_documento}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Tipo: </b> {this.props.formularioValues.tipo_veiculo}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Negociador</b> {this.props.formularioValues.nome_negociador}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Cliente</b> {this.props.formularioValues.nome_cliente}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Recebedor</b> {this.props.formularioValues.nome_destinatario}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Local Coleta</b> {this.props.formularioValues.cidade_coleta} - {this.props.formularioValues.estado_coleta} - {this.props.formularioValues.pais_coleta}</div>
								<div style={{ fontSize: 14, padding: 4 }}><b>Local Entrega</b> {this.props.formularioValues.cidade_entrega} - {this.props.formularioValues.estado_entrega} - {this.props.formularioValues.pais_entrega}</div>
								<div style={{ fontSize: 14, padding: 4, display: 'flex', flexDirection: 'row' }}><b>Operação: </b> 
									<div
										style={{ 
											marginLeft: 4,
											paddingLeft: 8,
											paddingRight: 8,
											borderRadius: 10, 
											backgroundColor: this.props.formularioValues.cor_perfil, 
											color: ColorUtils.getCorFonte(this.props.formularioValues.cor_perfil) 
										}}>{`${this.props.formularioValues.nome_operacao || ''}${this.props.formularioValues.nome_perfil ? ' - ' : ''}${this.props.formularioValues.nome_perfil || ''}`}</div></div>
							</div>
						</Row>
					</ContentCardHeader>
				</ContentCard>}
				
				<ContentCard>					
					<Form event={this.props.handleSubmit}>
						<ContentCardBody>
							<Row>
								<Field
									name='datahora_ocorrencia'
									component={LabelAndInputMask}
									label='Data e Hora' placeholder='Informe a data e hora'
									cols='12 12 6 4'
									mask='99/99/9999 99:99'
									maxWidth={180}
									readOnly={!editaMes ? 'readOnly' : readOnly}
									value={this.props.formularioValues.datahora_ocorrencia}
									onChange={value => {
										this.props.initForm({
											...this.props.formularioValues,
											datahora_ocorrencia: value,
											alterandoData: true
										});
									}} />

								{this.props.formularioValues.multiplos ? (
									<Select
										options={this.props.listaMotorista}
										label='Motoristas'
										cols='12 12 4 3'
										placeholder='Selecione os motoristas'
										readOnly={''}
										multiple
										value={(this.props.formularioValues.motoristas || [])}
										onChange={value => {
											this.props.initForm({
												...this.props.formularioValues,
												motoristas: (value || []).map(item => parseInt(item.value))
											});
										}} />
								) : (
									<Field
										name='id_motorista'
										component={Select}
										options={this.props.listaMotorista}
										label='Motorista'
										cols='12 12 4 3'
										placeholder='Selecione o motorista'
										readOnly={!editaMes ? 'readOnly' : readOnly} />
								)}

								<Select
									name='id_tipo'
									options={this.props.listaTipo.filter(item => {
										
										if (item.data_inicio) {
											const dataVigencia = DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_inicio));
											const dataOcorrencia = DateFormat.formatarDataTelaParaSql((this.props.formularioValues.datahora_ocorrencia || '').split(' ')[0]);
											// console.log(`${dataOcorrencia} < ${dataVigencia} = ${dataOcorrencia < dataVigencia}`);
											if (dataOcorrencia < dataVigencia) {
												return false;
											}
										} 
										if (item.data_fim) {
											const dataVigencia = DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_fim));
											const dataOcorrencia = DateFormat.formatarDataTelaParaSql((this.props.formularioValues.datahora_ocorrencia || '').split(' ')[0]);
											// console.log(`${dataOcorrencia} > ${dataVigencia} = ${dataOcorrencia > dataVigencia}`);
											if (dataOcorrencia > dataVigencia) {
												return false;
											}
										}		
										
										if (isDocumentoVPR && !item.documentacao) {
											return false;
										}
										
										if (!this.props.usuarioCarregado) {
											return false;
										} else if (this.props.usuarioCarregado.acesso_ocorrencia) {
											return true;
										} else if (item.id_perfil == this.props.usuarioCarregado.id_perfil 
												|| (item.perfis || []).filter(perfil => perfil == this.props.usuarioCarregado.id_perfil).length) {
											return true;
										}

										return false;
									}).map(item => ({ ...item, valor: `${item.valor} (${item.id})`}))}
									label='Tipo'
									cols='12 12 3 2'
									placeholder='Selecione o tipo'
									readOnly={!editaMes ? 'readOnly' : readOnly}
									value={this.props.formularioValues.id_tipo}
									onChange={index => {
										let quantidade = parseInt(this.props.formularioValues.quantidade || 1);
										let tipo = this.props.listaTipo.filter(tipo => tipo.id == index)[0];
										let percentual = this.props.listaTipo.filter(tipo => tipo.id == index)[0] 
											? parseFloat(this.props.listaTipo.filter(tipo => tipo.id == index)[0].percentual_desconto || 0) 
											: 0;

										this.props.initForm({
											...this.props.formularioValues,
											id_tipo: index,
											quantidade: null,
											percentual_desconto: tipo && tipo.multiplica_percentual ? FormatUtils.formatarValorTela(0, 2) : FormatUtils.formatarValorTela(percentual, 2),
											finalizacao_automatica: tipo && tipo.finalizacao_automatica,
											permite_lancar_periodo_fechado: tipo && tipo.permite_lancar_periodo_fechado
										});
									}} />
								
								{this.props.listaTipo.filter(tipo => tipo.id == this.props.formularioValues.id_tipo)[0] 
								&& this.props.listaTipo.filter(tipo => tipo.id == this.props.formularioValues.id_tipo)[0].multiplica_percentual &&
								<SelectDefault
									options={this.props.formularioValues.id_tipo == 31 || this.props.formularioValues.id_tipo == 41 //Acidente
										? [{ id: 30, valor: '30%' }, { id: 60, valor: '60%' }, { id: 100, valor: '100%' }] 
										: (this.props.formularioValues.id_tipo == 49  ? //Velocidade
											[{ id: 0, valor: 'Isento' }, { id: 5, valor: '5%' }, { id: 15, valor: '15%' }, { id: 30, valor: '30%' }, { id: 50, valor: '50%' }]
											: [{ id: 5, valor: '5%' }, { id: 25, valor: '25%' }, { id: 50, valor: '50%' }, { id: 100, valor: '100%' }]
										)}
									label='Quantidade'
									cols='12 12 3 2'
									placeholder='Selecione a quantidade'
									readOnly={readOnly}
									value={this.props.formularioValues.quantidade}
									onChange={data => {
										let quantidade = parseInt(data.target.value || 0);
										let tipo = this.props.listaTipo.filter(tipo => tipo.id == this.props.formularioValues.id_tipo)[0];
										let percentual = tipo ? parseFloat(tipo.percentual_desconto || 0) : 0;

										this.props.initForm({
											...this.props.formularioValues,
											quantidade: quantidade,
											percentual_desconto: tipo && tipo.multiplica_percentual ? FormatUtils.formatarValorTela(quantidade, 2) : FormatUtils.formatarValorTela(percentual, 2)
										});
									}} />}

								<Field
									name='percentual_desconto'
									component={LabelAndInputNumber}
									label='Percentual de Desconto' placeholder='Informe o percentual'
									cols='12 12 3 2'
									casas={2}
									readOnly={'readOnly'} />

								<Field
									name='observacao'
									component={LabelAndInput}
									label='Observação' placeholder='Informe a observação'
									cols='12 12 12 12'
									readOnly={readOnly} />

							</Row>
							
							{/*APENAS CAMPOS PARA COMPROVANTES*/}
							{isDocumentoVPR ? (
								<Row>
									{this.props.formularioValues.avulsa && 
									<Field
										name='solicitacao'
										component={LabelAndInput}
										label='Solicitação' placeholder='Informe a solicitacao'
										cols='12 6 3 2'
										maxWidth={180}
										readOnly={readOnly} />}

									<Field
										name='id_status'
										component={Select}
										options={this.props.listaStatus}
										label='Status'
										cols='12 12 3 2'
										placeholder='Selecione o status'
										readOnly={readOnly} />

									<Field
										name='datahora_ocorrencia'
										component={LabelAndInputMask}
										label='Data da Constatação' placeholder='Informe a data e hora'
										cols='12 6 4 3'
										maxWidth={180}
										mask='99/99/9999 99:99'
										readOnly={'readOnly'} />
									
									<Field
										name='datahora_finalizacao'
										component={LabelAndInputMask}
										label='Data da Finalização' placeholder='Informe a data e hora'
										cols='12 6 4 3'
										maxWidth={180}
										mask='99/99/9999 99:99'
										readOnly={'readOnly'} />
										
									<Field
										name='id_acao'
										component={Select}
										options={this.props.listaAcao}
										label='Ação Requerida'
										cols='12 6 4 3'
										placeholder='Selecione a ação'
										readOnly={readOnly} />

									<Field
										name='id_area'
										component={Select}
										options={this.props.listaResponsabilidade}
										label='Área Responsável'
										cols='12 6 3 2'
										placeholder='Selecione o responsável'
										readOnly={readOnly} />
										
									<Field
										name='id_usuario_responsavel'
										component={Select}
										options={this.props.listaUsuario}
										label='Usuário Responsável'
										cols='12 6 4 3'
										placeholder='Selecione o responsável'
										readOnly={readOnly} />
										
									<Field
										name='id_usuario_aprovador'
										component={Select}
										options={this.props.listaUsuario}
										label='Usuário Aprovador'
										cols='12 6 4 3'
										placeholder='Selecione o aprovador'
										readOnly={readOnly } />
									
									<Field
										name='id_tipo_custo'
										component={Select}
										options={this.props.listaTipoCusto}
										label='Tipo de Custo'
										cols='12 6 4 3'
										placeholder='Selecione o tipo de custo'
										readOnly={this.props.gestao ? 'readOnly' : readOnly && !acessoAprovador} />
										
									<Select
										name='parecer'
										options={[{ id: 0, valor: 'Aguardando' }, { id: 1, valor: 'Aprovado' }, { id: 2, valor: 'Rejeitado' }]}
										label='Parecer'
										cols='12 6 4 3'
										placeholder='Selecione o parecer'
										readOnly={this.props.gestao ? 'readOnly' : readOnly && !acessoAprovador}
										value={JSON.parse(this.props.formularioValues.parecer || null) == true ? 1 : (JSON.parse(this.props.formularioValues.parecer || null) == false ? 2 : 0)}
										onChange={(value) => {
											this.props.initForm({
												...this.props.formularioValues,
												parecer: value == 1 ? true : (value == 2 ? false : null)
											})
										}} />
										
									<Field
										name='valor'
										component={LabelAndInputNumber}
										label='Valor (R$)' placeholder='Informe o valor'
										cols='12 6 3 2'
										casas={2}
										readOnly={readOnly} />
										
									<Field
										name='valor_autorizado'
										component={LabelAndInputNumber}
										label='Valor Autorizado (R$)' placeholder='Informe o valor'
										cols='12 6 3 2'
										casas={2}
										readOnly={this.props.gestao ? 'readOnly' : readOnly && !acessoAprovador} />	

									<Field
										name='email_copia'
										component={LabelAndInput}
										label='E-mails para notificar (separar por vírgula)' placeholder='Informe os e-mail'
										cols='12 12 6 8'
										readOnly={readOnly} />						
										
									{this.props.formularioValues.id ? (
									<Field
										name='comentario'
										component={LabelAndInput}
										label='Comentário' placeholder='Informe o comentário'
										cols='12 12 12 12'
										readOnly={this.props.gestao ? 'readOnly' : (readOnly && !acessoResponsavel && !acessoAprovador)} />) : null}

									<Grid cols='12 12 12 12'>
										<Table responsive>
											<TBody>
												{listaComentarios.map(item => (
													<Tr key={item.id}>
														<Td minWidth={100}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_historico)}</Td>
														<Td minWidth={100} alignCenter>{item.nome_usuario || ''}</Td>
														<Td minWidth={700} alignCenter>
															<input className='form-control'
																readOnly={'readOnly'}
																value={item.atual || ''} />
														</Td>
													</Tr>
												))}
											</TBody>
										</Table>
									</Grid>

									{this.props.formularioValues.datahora_interacao 
										&& this.props.formularioValues.id_usuario_responsavel != this.props.sessao.id ? (
										this.props.formularioValues.datahora_interacao > this.props.formularioValues.datahora_comentario_visto 
										|| !this.props.formularioValues.datahora_comentario_visto ? (
											<Grid cols='12 12 12 12' style={{ paddingBottom: 20 }}>
												<Button
													text='Li todos os comentários ainda não visualizados'
													type={'primary'}
													icon={'fa fa-plus'}
													event={() => {
														this.props.salvarComentarioVisto({ ...this.props.formularioValues });
														this.props.initForm({ ...this.props.formularioValues, datahora_comentario_visto:  DateFormat.getDataHoraAtual() });
													}} />
											</Grid>
										) : null
									) : null}

								</Row>
							) : null}

							{this.props.tratativa &&
							<Row>
								<Grid cols='12 12 12 12'>
									<label>Possui tratativa com o motorista?</label>
								</Grid>
								<LabelAndCheckbox
									maxWidth={70}
									label='Sim'
									placeholder='Informe'
									cols='12 12 12 12'
									readOnly={readOnly}
									value={this.props.formularioValues.possui_tratativa}
									onChange={value => {
										this.props.initForm({
											...this.props.formularioValues,
											possui_tratativa: true
										});
									}} />
								<LabelAndCheckbox
								 	maxWidth={70}
									label='Não'
									placeholder='Informe'
									cols='12 12 12 12'
									readOnly={readOnly}
									value={!this.props.formularioValues.possui_tratativa}
									onChange={value => {
										this.props.initForm({
											...this.props.formularioValues,
											possui_tratativa: false
										});
									}} />
							</Row>}

							{(this.props.formularioValues.possui_tratativa && !readOnly) && 
							<Row>
								<LabelAndInput
									label='Descrição da tratativa'
									placeholder='Informe a descrição'
									cols='12 12 6 4'
									readOnly={readOnly}
									value={this.state.descricao_tratativa}
									onChange={data => {
										this.setState({
											...this.state,
											descricao_tratativa: data.target.value
										});
									}} />

								<LabelAndInputDate
									label='Data da Tratativa'
									cols='12 6 4 4'
									value={this.state.data_tratativa}
									datetime
									onChange={value => {
										this.setState({
											...this.state,
											data_tratativa: value
										});
									}} />

								<ButtonTable
									type={'success'}
									icon={'fas fa-plus'}
									visible={true}
									disabled={!this.state.data_tratativa || !this.state.descricao_tratativa}
									height={38}
									marginTop={29}
									marginLeft={8}
									event={() => {
										if (this.props.formularioValues.id) {
											this.props.salvarTratativa({
												id_ocorrencia: this.props.formularioValues.id,
												data_tratativa: this.state.data_tratativa,
												descricao: this.state.descricao_tratativa
											}, () => {
												this.setState({
													...this.state,
													descricao_tratativa: '',
													data_tratativa: null
												});
											});
										} else {
											let tratativas = (this.props.formularioValues.tratativas || []).map(item => item);
											tratativas.push({
												idAux: new Date().getTime(),
												data_tratativa: this.state.data_tratativa,
												descricao: this.state.descricao_tratativa,
												id_usuario_inclusao: this.props.sessao.id,
												nome_usuario_inclusao: this.props.sessao.nome
											});
											this.props.initForm({
												...this.props.formularioValues,
												tratativas: tratativas
											});
											this.setState({
												...this.state,
												descricao_tratativa: '',
												data_tratativa: null
											});
										}
									}} />								

							</Row>}

							{(this.props.formularioValues.possui_tratativa && (
								this.props.formularioValues.tratativas || this.props.listaTratativas.length > 0
							)) && 
							<Row>
								<Grid cols='12 12 8 6'>
									<Table responsive>
										<THead>
											<Tr>
												<Th width={150}>Usuário</Th>
												<Th width={300} alignCenter>Tratativa</Th>
												<Th width={100} alignCenter>Data</Th>
												<Th width={50} alignCenter></Th>
											</Tr>
										</THead>
										<TBody>
											{(this.props.formularioValues.tratativas || this.props.listaTratativas).map(item => (
												<Tr key={item.id || item.idAux}>
													<Td small>{item.nome_usuario_inclusao}</Td>
													<Td small alignCenter>{item.descricao}</Td>
													<Td small alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_tratativa)}</Td>
													<Td small alignCenter>
														{item.id_usuario_inclusao == this.props.sessao.id &&
														<ButtonTable
															small
															type={'danger'}
															icon={'fas fa-trash-alt'}
															visible={!readOnly}
															event={() => {
																if (window.confirm('Deseja realmente remover?')) {
																	if (this.props.formularioValues.id) {																	
																		this.props.excluirTratativa({
																			...item
																		});
																	} else {
																		this.props.initForm({
																			...this.props.formularioValues,
																			tratativas: (this.props.formularioValues.tratativas || []).filter(tratativa => tratativa.idAux != item.idAux)
																		});
																	}
																}
															}} />}
													</Td>
												</Tr>
											))}
										</TBody>
									</Table>
								</Grid>
							</Row>}

							<Row>
								<Grid cols='12 12 12 12'>
									<label>Arquivo</label>
								</Grid>
								{(this.props.formularioValues.arquivo || []).map(arquivo => (
									<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8 }}>
										<span class="btn btn-outline-primary fileinput-button dz-clickable">
											<img src={arquivo.arquivo_base64 ? pdfAdicionado : (arquivo.arquivo ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
										</span>
										<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
											<button
												type='button'
												class='btn btn-flat btn-outline-primary'
												style={{ width: '48%' }}
												disabled={arquivo.arquivo_base64 ? true : false}
												onClick={() => {
													window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
												}}>
												<i class='fas fa-download'></i>
											</button>

											<button
												type='button'
												class='btn btn-flat btn-outline-danger'
												style={{ width: '48%' }}
												disabled={this.props.gestao ? 'readOnly' : (readOnly && !acessoResponsavel && !acessoAprovador)}
												onClick={() => {
													this.props.initForm({
														...this.props.formularioValues,
														arquivo: this.props.formularioValues.arquivo.filter(item => item != arquivo)
													});
												}}>
												<i class='fas fa-trash-alt'></i>
											</button>
										</div>
									</div>
								))}
								{!this.props.gestao && (!readOnly || acessoResponsavel  || acessoAprovador) ? (
									<span class="btn btn-outline-primary fileinput-button dz-clickable" 
										style={{ marginLeft: 8 }}
										onClick={() => this.fileSelectorArquivo.click()}>
										<img src={pdfAdd} style={{ height: 30 }} />
									</span>
								) : null}
							</Row>

							{/*
							TELA DA GESTÃO
							*/}
							
							{this.props.gestao &&
							<>
								<Row style={{ marginTop: 20 }}>
									<LabelAndInput
										label='Comentário da Gestão'
										placeholder='Informe'
										cols='12 12 8 6'
										readOnly={gestaoFinalizada}
										value={this.state.descricao_comentario_gestao}
										onChange={data => {
											this.setState({
												...this.state,
												descricao_comentario_gestao: data.target.value
											});
										}} />

									<ButtonTable
										type={'success'}
										icon={'fas fa-plus'}
										visible={true}
										disabled={!this.state.descricao_comentario_gestao}
										height={38}
										marginTop={29}
										marginLeft={8}
										event={() => {
											this.props.salvarComentarioGestao({
												id_ocorrencia: this.props.formularioValues.id,
												descricao: this.state.descricao_comentario_gestao
											}, () => {
												this.setState({
													...this.state,
													descricao_comentario_gestao: ''
												});
											});
										}} />
								</Row>

								{this.props.listaComentarioGestao.length > 0 && 
								<Row>
									<Grid cols='12 12 8 6'>
										<Table responsive>
											<THead>
												<Tr>
													<Th width={150}>Gestor</Th>
													<Th width={300} alignCenter>Comentário</Th>
													<Th width={100} alignCenter>Data</Th>
													<Th width={50} alignCenter></Th>
												</Tr>
											</THead>
											<TBody>
												{this.props.listaComentarioGestao.map(item => (
													<Tr key={item.id || item.idAux}>
														<Td small>{item.nome_usuario_inclusao}</Td>
														<Td small alignCenter>{item.descricao}</Td>
														<Td small alignCenter>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</Td>
														<Td small alignCenter>
															{(item.id_usuario_inclusao == this.props.sessao.id && !gestaoFinalizada) &&
															<ButtonTable
																small
																type={'danger'}
																icon={'fas fa-trash-alt'}
																visible={true}
																event={() => {
																	if (window.confirm('Deseja realmente remover?')) {
																		this.props.excluirComentarioGestao({
																			...item
																		});
																	}
																}} />}
														</Td>
													</Tr>
												))}
											</TBody>
										</Table>
									</Grid>
								</Row>}

								<Row>
									<Grid cols='12 12 12 12' style={{ maxWidth: 140, minWidth: 140 }}>
										<Row>
											<Grid cols='12 12 12 12'>
												<label>Abona?</label>
											</Grid>
											<LabelAndCheckbox
												maxWidth={70}
												label='Sim'
												placeholder='Informe'
												cols='12 12 12 12'
												readOnly={gestaoReciclagem || gestaoFinalizada}
												value={this.props.formularioValues.abona}
												onChange={value => {
													this.props.initForm({
														...this.props.formularioValues,
														abona: true
													});
												}} />
											<LabelAndCheckbox
												maxWidth={70}
												label='Não'
												placeholder='Informe'
												cols='12 12 12 12'
												readOnly={gestaoReciclagem || gestaoFinalizada}
												value={!this.props.formularioValues.abona}
												onChange={value => {
													this.props.initForm({
														...this.props.formularioValues,
														abona: false
													});
												}} />
										</Row>
									</Grid>	
									{this.props.formularioValues.abona &&
									<Field
										name='abona_justificativa'
										component={LabelAndInput}
										label='Justificativa'
										placeholder='Informe'
										cols='12 12 8 6'
										readOnly={gestaoReciclagem || gestaoFinalizada}
										 />}
								</Row>

								<Row>
									<Grid cols='12 12 12 12'>
										<label>Encaminhar para reciclagem?</label>
									</Grid>
									<LabelAndCheckbox
										maxWidth={70}
										label='Sim'
										placeholder='Informe'
										cols='12 12 12 12'
										readOnly={gestaoReciclagem || gestaoFinalizada}
										value={this.props.formularioValues.reciclagem}
										onChange={value => {
											this.props.initForm({
												...this.props.formularioValues,
												reciclagem: true
											});
										}} />
									<LabelAndCheckbox
										maxWidth={70}
										label='Não'
										placeholder='Informe'
										cols='12 12 12 12'
										readOnly={gestaoReciclagem || gestaoFinalizada}
										value={!this.props.formularioValues.reciclagem}
										onChange={value => {
											this.props.initForm({
												...this.props.formularioValues,
												reciclagem: false
											});
										}} />
								</Row>
								<Row>
									{this.props.formularioValues.reciclagem &&
									<Select
										options={this.props.listaUsuario.filter(item => item.ocorrencia_instrutor)}
										label='Instrutores'
										cols=' 12 12 8 6'
										placeholder='Selecione'
										multiple
										value={this.props.formularioValues.ids_instrutores}
										readOnly={gestaoReciclagem || gestaoFinalizada}
										onChange={values => {
											this.props.initForm({
												...this.props.formularioValues,
												ids_instrutores: values.map(item => item.value)
											});
										}} />}
								</Row>

								<Row>
									<Grid cols='12 12 12 12'>
										<label>Arquivo</label>
									</Grid>
									{(this.props.formularioValues.arquivo_gestao || []).map(arquivo => (
										<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8 }}>
											<span class="btn btn-outline-primary fileinput-button dz-clickable">
												<img src={arquivo.arquivo_base64 ? pdfAdicionado : (arquivo.arquivo ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
											</span>
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
												<button
													type='button'
													class='btn btn-flat btn-outline-primary'
													style={{ width: '48%' }}
													// disabled={arquivo.arquivo_base64 ?true : false}
													onClick={() => {
														window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
													}}>
													<i class='fas fa-download'></i>
												</button>

												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: '48%' }}
													disabled={gestaoFinalizada || (readOnly && !acessoResponsavel && !acessoAprovador)}
													readOnly={gestaoFinalizada}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															arquivo_gestao: this.props.formularioValues.arquivo_gestao.filter(item => item != arquivo)
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										</div>
									))}
									{!gestaoFinalizada &&
									<span class="btn btn-outline-primary fileinput-button dz-clickable" 
										style={{ marginLeft: 8 }}
										onClick={() => this.fileSelectorArquivoGestao.click()}>
										<img src={pdfAdd} style={{ height: 30 }} />
									</span>}
								</Row>
							</>}

						</ContentCardBody>
						<ContentCardFooter>
							<Row alignCenter>
								<Grid cols='6 6 4 3'>
									{this.props.excluir ? (
										<Button
											text='Excluir'
											submit type={'danger'}
											icon={'fa fa-trash'}
											disabled={!podeExcluir}
											title={podeExcluir ? null : 'Solicite ao Supervisor'} />
									) : (this.props.gestao ? (

										// 1 - Aberta
										// 2 - Em Andamento
										// 3 - Em Reciclagem
										// 4 - Finaliza

										<Button
											text={
												[1, 2].includes(this.props.formularioValues.id_status_gestao) && this.props.formularioValues.reciclagem
													? 'Enviar para Reciclagem' : 'Finalizar'
											}
											type={'success'}
											icon={'fa fa-check'}
											disabled={this.props.formularioValues.id_status_gestao == 4}
											event={() => {
												if (window.confirm(
													[1, 2].includes(this.props.formularioValues.id_status_gestao) && this.props.formularioValues.reciclagem
														? 'Deseja realmente enviar para reciclagem' 
														: 'Deseja realmente finalizar?'
												)) {
													this.props.salvar({
														...this.props.formularioValues,
														id_status_gestao: [1, 2].includes(this.props.formularioValues.id_status_gestao) && this.props.formularioValues.reciclagem
															? 3 : 4
													});
												}
											}} />
									) : (
										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
									))}
								</Grid>
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => this.props.voltarComprovante ? this.props.voltarComprovante() : this.props.setModoTela('lista')} />
								</Grid>
							</Row>
						</ContentCardFooter>
					</Form>
				</ContentCard>

				{/*APENAS CAMPOS PARA COMPROVANTES*/}
				{isDocumentoVPR ? (
					this.renderHistorico()
				) : null}
			</>
        )
    }

	renderHistorico(readOnly) {
		
		return (
			<>
				<ContentCard>
					<ContentCardHeader>
						<label>Histórico</label>
					</ContentCardHeader>
					<ContentCardBody>
						<Table responsive>
							<THead>
								<Tr>
									<Th>Data/Hora</Th>
									<Th alignCenter>Operação</Th>
									<Th alignCenter>Registro</Th>
									<Th alignCenter>Anterior</Th>
									<Th alignCenter>Atual</Th>
									<Th alignCenter>Descrição</Th>
									<Th alignCenter>Usuário</Th>
								</Tr>
							</THead>
							<TBody>
								{this.props.listaHistorico.map(item => (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`} >
										<Td small >{DateFormat.formatarDataHoraSqlParaTela(item.datahora_historico)}</Td>
										<Td small alignCenter>{item.tipo}</Td>
										<Td small alignCenter>{item.nome}</Td>
										<Td small alignCenter>{(item.coluna == 'valor' || item.coluna == 'valor_autorizado' || item.coluna == 'percentual_desconto')
											? FormatUtils.formatarValorTela(item.anterior, 2) : (item.anterior || '')}</Td>
										<Td small alignCenter>{(item.coluna == 'valor' || item.coluna == 'valor_autorizado' || item.coluna == 'percentual_desconto')
											? FormatUtils.formatarValorTela(item.atual, 2) : (item.atual || '')}</Td>
										<Td small alignCenter>{item.descricao || ''}</Td>
										<Td small alignCenter>{item.nome_usuario || ''}</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</ContentCardBody>
				</ContentCard>
			</>
		);
	}


}

OcorrenciaForm = reduxForm({form: 'ocorrenciaForm', destroyOnUnmount: false})(OcorrenciaForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('ocorrenciaForm')(state),
	registro: state.ocorrencia.registro,
	listaTipo: state.ocorrencia.listaTipo,
	listaMotorista: state.ocorrencia.listaMotorista,
	listaGravidade: state.ocorrencia.listaGravidade,
	listaLocal: state.ocorrencia.listaLocal,
	listaResponsabilidade: state.ocorrencia.listaResponsabilidade,
	listaTipoCusto: state.ocorrencia.listaTipoCusto,
	listaStatus: state.ocorrencia.listaStatus,
	listaAcao: state.ocorrencia.listaAcao,
	listaUsuario: state.ocorrencia.listaUsuario,
	listaHistorico: state.ocorrencia.listaHistorico,
	listaTratativas: state.ocorrencia.listaTratativas,
	listaComentarioGestao: state.ocorrencia.listaComentarioGestao
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, gerarBoletim, salvar, getListaHistorico, salvarComentarioVisto,
	salvarTratativa, excluirTratativa, getListaTratativa,
	salvarComentarioGestao, excluirComentarioGestao, getListaComentarioGestao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(OcorrenciaForm);